export default __webpack_public_path__ + "static/media/ludovico-lovisetto-t-BU61kt6Cw-unsplash.8facc556.jpg";